import React from "react"
import Markdown from "markdown-to-jsx"

export const getCompiler = (elements, components) => {
  // eslint-disable-next-line
  return (markdownString) => (
    <Markdown
      options={{
        overrides: { ...elements, ...components },
        forceBlock: true
      }}
    >
      {markdownString}
    </Markdown>
  )
}
